export default "__VITE_ASSET__KqfkyDsr__"